export default function SeverityPill({ severity, testId }) {
  const s = (severity || "amber").toLowerCase();
  const cls = s === "red" ? "pill-red" : s === "green" ? "pill-green" : "pill-amber";
  return (
    <span className={`pill ${cls}`} data-testid={testId || `pill-${s}`}>
      <span className="dot" aria-hidden />
      {s}
    </span>
  );
}
